<div class="page-body">
  <div class="row">
    <!-- Discussion-detail-left start -->
    <div class="col-xl-8 col-12 stop-overflow">
      <!-- Discussion-content -->
      <discussion-content-section
        [currentUser]="currentUser"
        [discussion]="discussion"
        [canModifyDiscussion]="canModifyDiscussion"
        [currentPanelMember]="currentPanelMember"
      >
      </discussion-content-section>

      <!-- Discussion-comments -->
      <comment-list
        [currentUser]="currentUser"
        [currentPanelMember]="currentPanelMember"
        [discussion]="discussion"
        [config]="config"
      >
      </comment-list>
    </div>
    <!-- Discussion-detail-left end -->

    <!-- Discussion-detail-right start -->
    <discussion-meta-section
      class="col-xl-4 col-12 task-detail-right stop-overflow"
      [currentUser]="currentUser"
      [discussion]="discussion"
      [canModifyDiscussion]="canModifyDiscussion"
      [currentPanelMember]="currentPanelMember"
    >
    </discussion-meta-section>
    <!-- Discussion-detail-right end -->
  </div>
</div>
